import { TextProps } from '@chakra-ui/react';
import { specialFont } from 'constants/theme';
import { Text } from 'components/UI';

const TextWhite = ({ children, ...props }: TextProps) => (
  <Text color="white" fontFamily={specialFont} letterSpacing={3} lineHeight={1} fontSize="sm" {...props}>
    {children}
  </Text>
);

export default TextWhite;
